import React, { useEffect } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import MarketList from './components/MarketList'
import PricingDetailsPanel from './components/PricingDetailsPanel'
import styles from './style.module.css'
import { usePricingStore } from './pricingStore'

const PricingPage = ({ match, location, history }) => {
	const { loadMarkets, hasMarketsInitiallyLoaded } = usePricingStore()

	useEffect(() => {
		if (!hasMarketsInitiallyLoaded) {
			loadMarkets()
		}
	}, [hasMarketsInitiallyLoaded, loadMarkets])

	return (
		<div
			className='container'
			style={{ marginTop: 20, marginBottom: '100px', display: 'flex' }}
		>
			<Route path={match.path} component={MarketList} />
			<div className={styles.divider} />
			<Switch>
				<Route exact path={match.path} component={PricingDetailsPanel} />
				<Route
					path={`${match.path}/markets/:market`}
					component={PricingDetailsPanel}
				/>
				<Route
					path={`${match.path}/clients/:clientId`}
					component={PricingDetailsPanel}
				/>
			</Switch>
		</div>
	)
}

export default withRouter(PricingPage)
